import classNames from 'classnames';
import styles from './Options.module.css';

function OptionsRadio({
  selected,
}: {
  selected?: boolean
}) {
  return (
    <div className={classNames(styles.radioOuterDot, {
      [styles.selected]: selected,
    })}
    >
      <div className={classNames(styles.radioInnerDot, {
        [styles.selected]: selected,
      })}
      />
    </div>
  );
}

OptionsRadio.defaultProps = {
  selected: false,
};
export default OptionsRadio;
